import { render, staticRenderFns } from "./VerificacaoCpf.vue?vue&type=template&id=1fa4b11d&scoped=true&"
import script from "./VerificacaoCpf.vue?vue&type=script&lang=js&"
export * from "./VerificacaoCpf.vue?vue&type=script&lang=js&"
import style0 from "./VerificacaoCpf.vue?vue&type=style&index=0&id=1fa4b11d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa4b11d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VDivider,VForm,VIcon,VTextField})
